import React, { createContext, useState } from 'react'
import { Modal } from 'react-bootstrap'
import Confetti from 'react-confetti'

export const UserContext = createContext()
export const PopUpContext = createContext()
export const OrdersContext = createContext()
export const conffetiContext = createContext()

export default function Root({ children }) {
   const [user, setUser] = useState({ table: 10, name: 'michael', type: 'client', _id: '111' })
   const [popUp, setPopUp] = useState()
   const [TotalOrders, setTotalOrders] = useState([])
   const [conffeti, setConffeti] = useState(false)

   return (
      <UserContext.Provider value={[user, setUser]}>
         <OrdersContext.Provider value={[TotalOrders, setTotalOrders]} >
            <PopUpContext.Provider value={[popUp, setPopUp]}>
               <conffetiContext.Provider value={[conffeti, setConffeti]}>

                  <div data-bs-theme="dark" style={{ minHeight: '100vh' }} className="bg-dark text-light ">
                     {children}
                  </div>

                  {popUp &&
                     <Modal show={true} fullscreen={false} onHide={() => setPopUp()}>
                        <Modal.Header className='bg-dark text-light' closeButton>
                           <Modal.Title>{popUp.title}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className='bg-dark text-light'>{popUp.component}</Modal.Body>
                     </Modal>}

                  {conffeti &&
                     <Confetti numberOfPieces={1400} gravity={0.1} recycle={false} onConfettiComplete={() => setConffeti()} />}

               </conffetiContext.Provider>
            </PopUpContext.Provider>
         </OrdersContext.Provider>
      </UserContext.Provider>
   )
}
